export interface AlertaPolifarmacia {
  tipo: 'QUEDA_HIPOTENSAO' | 'DUPLO_AINE' | 'INTERACAO_GERIATRICA';
  mensagem: string;
  severidade: 'ALTA' | 'MODERADA';
}

/**
 * Radar de Polifarmácia e Proteção de Idosos (Critérios de Beers):
 * Cruza o evento medicamentoAdicionado da MeMed em tempo real com o histórico
 * de medicamentos ativos do prontuário para prevenir quedas e lesão renal.
 */
export function verificarRiscoPolifarmacia(
  medicamentoNovoNome: string,
  medicamentosEmUso: Array<{ nome: string; classe?: string }> = [],
  pacienteIdade?: number,
): AlertaPolifarmacia | null {
  const nomeNovo = (medicamentoNovoNome || '').toLowerCase();
  const isIdoso = (pacienteIdade || 0) >= 60;

  // Regra 1: Sedativos / Hipnóticos + Anti-hipertensivo (Critérios de Beers)
  const isSedativo =
    nomeNovo.includes('clonazepam') ||
    nomeNovo.includes('diazepam') ||
    nomeNovo.includes('zolpidem') ||
    nomeNovo.includes('alprazolam') ||
    nomeNovo.includes('lorazepam') ||
    nomeNovo.includes('midazolam');

  if (isSedativo) {
    const jaUsaAntiHipertensivo = medicamentosEmUso.some((m) => {
      const n = (m.nome || '').toLowerCase();
      return (
        m.classe === 'ANTI-HIPERTENSIVO' ||
        n.includes('losartana') ||
        n.includes('enalapril') ||
        n.includes('hidroclorotiazida') ||
        n.includes('atenolol') ||
        n.includes('anlodipino')
      );
    });

    if (jaUsaAntiHipertensivo || isIdoso) {
      return {
        tipo: 'QUEDA_HIPOTENSAO',
        severidade: 'ALTA',
        mensagem:
          '⚠️ ALERTA DE POLIFARMÁCIA: Associação de sedativo/hipnótico com medicação cardiovascular eleva expressivamente o risco de hipotensão postural e quedas noturnas.',
      };
    }
  }

  // Regra 2: Duplicidade de AINEs (Risco Renal e Hemorragia Digestiva)
  const isAine =
    nomeNovo.includes('ibuprofeno') ||
    nomeNovo.includes('cetoprofeno') ||
    nomeNovo.includes('diclofenaco') ||
    nomeNovo.includes('nimesulida') ||
    nomeNovo.includes('meloxicam') ||
    nomeNovo.includes('piroxicam');

  if (isAine) {
    const jaUsaAine = medicamentosEmUso.some((m) => {
      const n = (m.nome || '').toLowerCase();
      return (
        m.classe === 'AINE' ||
        n.includes('ibuprofeno') ||
        n.includes('cetoprofeno') ||
        n.includes('diclofenaco') ||
        n.includes('nimesulida') ||
        n.includes('aas') ||
        n.includes('ácido acetilsalicílico')
      );
    });

    if (jaUsaAine) {
      return {
        tipo: 'DUPLO_AINE',
        severidade: 'ALTA',
        mensagem:
          '⚠️ ALERTA CLÍNICO: Possível duplicidade de Anti-inflamatórios Não Esteroidais (AINE). Risco elevado de lesão renal aguda e sangramento digestivo.',
      };
    }
  }

  return null;
}
